<template>
  <Image
    v-for="(image, index) in images"
    :key="image.id"
    :url="image.url"
    :remove="remove"
    :confirm="confirm"
    :class="props.class"
    @remove="$emit('remove', image.id)"
    @click="$emit('view', index)"
  />
</template>

<script setup>
import { Image } from "@/SharedComponents/Images";

defineEmits(["remove", "view"]);

const props = defineProps({
  images: { type: Array, required: true },
  remove: { type: Boolean, required: false },
  confirm: { type: Boolean, default: true },
  class: { type: null, required: false },
});
</script>
